import FlashingLight from "./flashing-light";

const Timer = ({ days, hours, minutes, completed }) => {
  if (completed) {
    // Render a complete state
    return (
      <p className="text-primary-text font-semibold text-xl ml-3">
        Competition Ended
      </p>
    );
  } else {
    // Render a countdown
    return (
      <div className="flex items-center">
        <FlashingLight />
        <span className="text-primary-text font-semibold text-xl ml-3">
          {days} days {hours} hours {minutes} mins
        </span>
      </div>
    );
  }
};

export default Timer;
